import { Injectable } from '@angular/core';
import {Observable, ReplaySubject} from "rxjs";
import {CountedAndPaginated} from "../interface/response/counted-and-paginated";
import {ockPolicy} from "../interface/ockPolicy";
import {HttpClient} from "@angular/common/http";
import {FilterService} from "./filter.service";
import {first, take} from "rxjs/operators";
import {ockCompany} from "../interface/ockCompany";
import {Uuid} from "../interface/response/uuid";

@Injectable({
  providedIn: 'root'
})
export class OckCompanyService {
  private readonly listSubject: ReplaySubject<CountedAndPaginated<ockCompany>>
    = new ReplaySubject<CountedAndPaginated<ockCompany>>(1);

  constructor(
    private httpClient: HttpClient,
    private filterService: FilterService
  ) { }

  public getListSubject(): ReplaySubject<CountedAndPaginated<ockCompany>> {
    return this.listSubject;
  }

  public loadList(page: number, pageSize: number, filters: object): void {
    this.httpClient.get(`/rest/crm/ock/company?page=${page + 1}&pageSize=${pageSize}&` + this.filterService.parseFilters(filters))
      .pipe(take(1))
      .subscribe((result: CountedAndPaginated<ockCompany>) => {
        this.listSubject.next(result);
      });
  }

  public downloadReport(filters: object): Observable<Uuid> {
    return this.httpClient.post(`/rest/crm/ock/company/method/report?` + this.filterService.parseFilters(filters), {})
      .pipe(first()) as Observable<Uuid>;
  }
}
